export const DawConfig = {
	TILES_PER_ROW									: 16,
	TILE_SIZE											: 128,
	SEED_NEIGHBOORING_RADIUS			: 35
}

export default DawConfig